const testimonials = [
  {
    initials: 'M.R.',
    role: 'General Contractor, Las Vegas',
    quote: 'Quiroz Construction Cleaning handled the final clean on a large commercial build we completed in Las Vegas. The crew was professional, thorough, and had the space move-in ready ahead of schedule. We\'ll be using them on every project going forward.',
  },
  {
    initials: 'D.T.',
    role: 'Property Developer, Las Vegas NV',
    quote: 'We needed post-construction cleaning done fast and done right. Quiroz delivered exactly that — detailed, reliable, and no corners cut. The finished space looked incredible for the client walkthrough.',
  },
  {
    initials: 'J.L.',
    role: 'Construction Project Manager',
    quote: 'Finding a construction cleaning company in Las Vegas that actually understands job site timelines is rare. Quiroz gets it. They coordinate around our schedule and always show up ready to work.',
  },
];

export default function Testimonials() {
  return (
    <section className="bg-[#1a1a1a] py-24 px-6 md:px-16 lg:px-24">
      <div className="text-center mb-14">
        <div className="inline-flex items-center gap-2 mb-4">
          <div className="w-8 h-px bg-[#C9A84C]"></div>
          <span className="font-inter text-[#C9A84C] text-xs tracking-widest uppercase">What Clients Say</span>
          <div className="w-8 h-px bg-[#C9A84C]"></div>
        </div>
        <h2 className="font-barlow-condensed font-900 text-white text-4xl md:text-5xl leading-none">
          TRUSTED BY BUILDERS<br /><span className="text-[#C9A84C]">ACROSS LAS VEGAS</span>
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {testimonials.map((t) => (
          <div key={t.initials} className="bg-white/5 border border-white/10 rounded-sm p-8 flex flex-col gap-6">
            <div className="flex gap-1">
              {[1,2,3,4,5].map((s) => (
                <i key={s} className="ri-star-fill text-[#C9A84C] text-sm"></i>
              ))}
            </div>
            <p className="font-inter text-white/70 text-sm leading-relaxed flex-1">&ldquo;{t.quote}&rdquo;</p>
            <div className="flex items-center gap-3 pt-4 border-t border-white/10">
              <div className="w-10 h-10 flex items-center justify-center bg-[#C9A84C] rounded-sm font-barlow font-800 text-[#1a1a1a] text-sm">{t.initials}</div>
              <div className="font-inter text-white/50 text-xs">{t.role}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
